import { numberWithCommas } from "../../../../Reports/Report_common_function";

export const columns = [
  "Sr",
  "Item Name",
  "Remarks",
  "Quantity",
  "Rate",
  "Amount",
  
];

export const Rows = (data) => {
    let sr = 1;
    let totalAmount = 0;
    let totalQty = 0;
  
    const rows = data.Items.map(item => {
      const qty = Number(item.Quantity || 0);
      const amt = Number(item.Amount || 0);
  
      totalQty += qty;
      totalAmount += amt;
  
      return [
        sr++,
        item.ItemName,
        item.Remarks || "",
        `${qty} ${item.UnitName}`,
        numberWithCommas(item.Rate.toFixed(2)),
        numberWithCommas(amt.toFixed(2)),
      ];
    });
  
    // ✅ TOTAL ROW (QTY + AMOUNT)
    rows.push([
      {
        content: 'TOTAL',
        colSpan: 3, // Sr + Item Name + Remarks
        styles: { halign: 'right', fontStyle: 'bold' }
      },
      {
        content: totalQty.toFixed(2),
        styles: { halign: 'right', fontStyle: 'bold' }
      },
      {
        content: '', // Rate column empty
      },
      {
        content: numberWithCommas(totalAmount.toFixed(2)),
        styles: { halign: 'right', fontStyle: 'bold' }
      }
    ]);
  
    return rows;
  };
  
  
